<!--结算记录列表-->
<template>
  <div>
    <Modal
      v-model="visibleShow"
      title="记录"
      width="1100"
      footer-hide
      @on-cancel="cancel"
    >
      <div class="work_drawer_details">
        <div class="detail-info">
          <div class="parts-title">基本信息</div>
          <div class="info_box" style="padding-left: 10px">
            <Row>
              <Col span="8"
                ><span class="tit">合作伙伴：</span
                ><span>{{ agent_name }}</span></Col
              >
              <Col span="8"
                ><span class="tit">联系人：</span
                ><span>{{ contacts_name }}</span></Col
              >
              <Col span="8"
                ><span class="tit">联系电话：</span
                ><span>{{ contacts_tel }}</span></Col
              >
            </Row>
          </div>
          <div class="parts-title">沟通记录：</div>
          <div class="record_list_box">
            <div
              class="item-top"
              :class="{ item: index > 0, right: item.type == 1 }"
              v-for="(item, index) in message"
              :key="index"
            >
              <div class="time">
                <span style="color: #47a753; margin-right: 5px">●</span>
                <span>{{ $moment(item.create_time) }}</span>

                <span style="margin-left: 20px">{{ item.username }}</span>
              </div>

              <div class="content_b">
                <div class="ds">
                  {{ item.content }}
                </div>
                <span class="f_item" v-for="(i, k) in item.enclosure" :key="k">
                  <a class="btn_look" target="_blank" :href="i.url"
                    >附件{{ k + 1 }}</a
                  >
                </span>
              </div>
            </div>
          </div>
          <div class="parts-title" style="margin-top: 45px">新建记录</div>
          <div class="message-box">
            <span style="color: #d40000">*</span>
            <span style="margin: 0 6px; color: #000">记录描述</span>
            <span style="color: #999">(必填项)</span>
            <div class="desc_input">
              <Input
                v-model="subimtMessage.describe"
                type="textarea"
                :autosize="{ minRows: 5 }"
                placeholder="此处限定5000字符"
              />
            </div>
            <div class="subtitle">上传附件</div>
            <div>
              <div class="up_box">
                <Button icon="md-add">添加附件</Button>
                <input
                  type="file"
                  class="file_input"
                  @change="uploadChangeFile"
                />
              </div>
              <p class="filt-tag" v-for="(item, index) in files" :key="index">
                <Tag closable @on-close="deleteFiles(index)"> {{ item }}</Tag>
              </p>
              <div class="description">
                可上传<span style="color: #f2935e">5个附件</span
                >每个附件大小不得超过8M。附件支持的格式有：'jpg','jpeg','bmp','png',<br />'gif','txt','rar','zip','doc','docx','ini','conf','eml','xlsx','xls','pdf',
              </div>
            </div>
            <Button
              type="primary"
              class="submit"
              v-preventReClick
              :loading="loading"
              :disabled="subimtMessage.describe ? false : true"
              @click="subimtMessages"
              >提交</Button
            >
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OSS from 'ali-oss'
import config from '@/config'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agent_id: {
      type: Number,
      default: 0
    },
    agent_name: {
      type: String,
      default: ''
    },
    contacts_name: {
      type: String,
      default: ''
    },
    contacts_tel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visibleShow: this.visible,
      message: [],
      subimtMessage: {
        describe: '',
        files: []
      },
      files: [],
      loading: false
    }
  },
  methods: {
    ...mapActions(['GetAgentTrack', 'SaveAgentTrack']),
    cancel () {
      this.$emit('cancel')
    },
    getData () {
      this.GetAgentTrack({ agent_id: this.agent_id }).then((res) => {
        res.data.map(item => {
          item.enclosure = JSON.parse(item.enclosure)
        })
        this.message = res.data
      })
    },
    deleteFiles (index) {
      this.files.splice(index, 1)
      this.subimtMessage.files.splice(index, 1)
    },
    uploadChangeFile (e) {
      console.log('上传的文件', e)
      let file = e.target.files[0]
      if (file.size > 5242880) {
        this.$Notice.warning({
          title: '上传失败',
          desc: `文件”${file.name}“过大`
        })
        return false
      }
      this.$Spin.show()
      let date = this.$moment(new Date(), 'YYYY-MM-DD')
      const OssClient = new OSS({
        region: config.oss.region,
        endpoint: config.oss.region,
        accessKeyId: config.oss.accessKeyId,
        accessKeySecret: config.oss.secretAccessKey,
        bucket: config.oss.bucket
      })
      OssClient.put('machine/log/' + date + '/' + file.name, file)
        .then((res) => {
          this.$Spin.hide()
          let url = {
            name: file.name,
            url: res.url
          }
          this.subimtMessage.files.push(url)
          this.files.push(file.name)
        })
        .catch((err) => {
          console.log(err)
          this.$Message.error('error')
        })
    },
    subimtMessages () {
      console.log('点击了')
      let data = {
        agent_id: this.agent_id,
        content: this.subimtMessage.describe,
        enclosure: JSON.stringify(this.subimtMessage.files)
      }
      this.loading = true
      this.SaveAgentTrack(data).then((res) => {
        this.loading = false
        if (res.status) {
          this.subimtMessage = {
            describe: '',
            files: []
          }
          this.message = []
          this.loading = false
          this.files = []
          this.cancel()
        } else {
          this.$Message.error(res.msg)
        }
      })
    }
  },
  computed: mapGetters({}),
  watch: {
    visible: function () {
      if (this.visible && this.agent_id) {
        this.getData()
      }
      this.visibleShow = this.visible
    }
  }
}
</script>

<style lang="less" scoped>
.work_drawer_details {
  padding-bottom: 80px;
  padding-left: 30px;
  .tit {
    color: black;
  }
  .parts-title {
    margin: 30px 0 16px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    position: relative;
    padding-left: 10px;
    &::after {
      content: " ";
      background-color: #d40000;
      width: 3px;
      height: 15px;
      position: absolute;
      left: 0;
      top: 3px;
    }
    &:first-of-type {
      margin: 10px 0 16px;
    }
  }
  .info_box {
    padding: 10px;
    background: #fffaf5;
    position: relative;
    .btn_off_order {
      position: absolute;
      top: 10px;
      right: 10px;
      color: #2d8cf0;
      cursor: pointer;
    }
  }
  .record_list_box {
    min-height: 50px;
    .item-top {
      margin-bottom: 15px;
      .time {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #a4a4a4;
      }
      .content_b {
        margin-top: 10px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .ds {
          color: #000;
        }
        .f_item {
          margin-left: 15px;
        }
        .btn_look {
          color: #2d8cf0;
          cursor: pointer;
          margin-left: 30px;
        }
      }
    }
    .item {
      .content_box {
        border: 1px solid #dcdee2;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .content_box {
        margin-right: 60px;
      }
    }
  }
}
.message-box {
  .desc_input {
    margin-top: 15px;
  }
  .subtitle {
    color: #000;
    margin: 20px 0 10px;
  }
  .description {
    margin-top: 10px;
  }
  .submit {
    margin-top: 26px;
    width: 80px;
  }
  .up_box {
    position: relative;
    margin-bottom: 10px;
    .file_input {
      position: absolute;
      top: 0;
      width: 100px;
      height: 100%;
      left: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
  .filt-tag {
    margin-bottom: 5px;
  }
}
</style>
